import { useMemo } from 'react';
import separarTitol from '../Compartido/separarTitol.js';
import { rutaPagina } from '../Compartido/contenidoCamprodon.js';

// Presentació de l'hotel (h1 de la portada) i imatge de "Sobre nosotros" a tot l'ample.
const Presentacion = ({ textos, lang, sobrenosotros, elementosweb, ruta }) => {

    const { titol, contingut } = useMemo(() => separarTitol(sobrenosotros?.ladesc), [sobrenosotros?.ladesc]);

    const imatge = sobrenosotros?.imagen_cabecera ? ruta + "/" + sobrenosotros.imagen_cabecera : null;

    return (
        <>
            <section className="c-presentation o-container text-center">
                {elementosweb?.subtitulo_propiedades?.[lang] && <div className="c-presentation__small-title text-uppercase">{elementosweb.subtitulo_propiedades[lang]}</div>}
                {titol && <h1 className="c-presentation__title">{titol}</h1>}
                <div className="c-presentation__content" dangerouslySetInnerHTML={{ __html: contingut }}></div>
                <a href={rutaPagina("hotel", lang)} className="c-link">{textos.presentacion.enlace}</a>
            </section>

            {imatge && <section className="full-slider">
                <div className="hc-js-slider">
                    <picture>
                        <img
                            src={imatge}
                            alt={textos.presentacion.alt}
                            className="image-cover full-slider__img"
                            width="100%"
                            height="100%"
                            loading="lazy"
                            decoding="async"
                        />
                    </picture>
                </div>
            </section>}
        </>
    );
};

export default Presentacion;
